// extracted by css-extract-rspack-plugin
export default {"infoIcon":"GlossaryInfoIcon-module__infoIcon___dVnoB"};